import type { ScreenModule } from "../../../app/screen-module";
import { ProgressDetailPage } from "../ProgressPages";

export default {
	id: "end-user.progress-detail",
	path: "/app/progress/:executionId",
	area: "end-user",
	label: "進捗詳細",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: ProgressDetailPage,
} satisfies ScreenModule;
